import { getEnvVariable } from 'src/utils/envUtils';
/**
 * Flattens an INavLink's branching (angular/SSO/proveRequired/VIS-DHMO) into a
 * plain FooterNavItem, mirroring NavLink.tsx's five render branches. Business
 * rules (SSO routing, legacy-app URL rewriting, identity-verification
 * gating) stay here in the app rather than in the design-system library.
 */
export function resolveNavItem(navLink, context) {
    const { translate, isIdentityVerified, navigationCheck, onNavigate } = context;
    const label = translate(navLink.label);
    const notify = () => onNavigate?.(navLink);
    if (navLink.angular) {
        return {
            label,
            url: getEnvVariable('mlpHomeUrl') + navLink.url,
            externalLink: true,
            onClick: notify,
        };
    }
    // SSO links have no real href - NavLink.tsx renders a bare <a> that relies
    // entirely on an onClick to open the SSO login window. Takes precedence
    // over proveRequired, matching NavLink.tsx (which never checks
    // proveRequired in this branch).
    if (navLink.externalLink && (navLink.cnvgSso || navLink.lamsSSO || navLink.l4bSso)) {
        const ssoGroup = navLink.cnvgSso ? 'cnvg' : navLink.lamsSSO ? 'lams' : 'l4b';
        return {
            label,
            url: '#',
            externalLink: true,
            onClick: (event) => {
                event.preventDefault();
                notify();
                window.open(`${getEnvVariable('mlpHomeUrl')}/customer/ssologin/${ssoGroup}`);
            },
        };
    }
    // VIS/DHMO: external link gated behind a navigation-confirmation dialog.
    if (navLink.externalLink && (navLink.id === 'VIS' || navLink.id === 'DHMO')) {
        return {
            label,
            url: navLink.url,
            externalLink: true,
            onClick: (event) => {
                event.preventDefault();
                notify();
                navigationCheck(() => window.open(navLink.url, '_blank'), navLink.id)();
            },
        };
    }
    const needsProve = navLink.proveRequired && !isIdentityVerified;
    if (navLink.externalLink) {
        return needsProve
            ? { label, url: '/prove', onClick: notify }
            : { label, url: navLink.url, externalLink: true, onClick: notify };
    }
    return {
        label,
        url: needsProve ? '/prove' : navLink.url,
        onClick: notify,
    };
}
